import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import './styles.module.scss';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';

// 前端頁面
export default class WidgetFacebookMall extends Component {
  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({ isFetchData: true });

    whttp.sharedGet(API_HOST + `/api/account/giveme5`, {}, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        console.error(reason);
        return;
      }

      this.setState(
        {
          posts: _.get(data, 'facebook_mall', []),
          igPostInfo: _.get(data, 'instagram.0'),
        },
        () => {
          if (window.FB) {
            window.FB.init({ xfbml: true, version: 'v6.0' });
          }
          if (window.instgrm) window.instgrm.Embeds.process();
        }
      );
    });
  };

  render() {
    const postInfo = _.get(this, 'state.posts.0', {});
    const igLink = _.get(this, 'state.igPostInfo.link');
    const found = _.get(postInfo, 'link', '').match(
      /https:\/\/www.facebook.com\/(\d*)_(\d*)/
    );
    const postId = _.get(found, '2');
    const fbLink = postId
      ? `https://www.facebook.com/cec.mall.tw/posts/${postId}`
      : null

    console.log('re');

    return (
      <Fragment>
        {fbLink && (
          <Fragment>
            <script
              async=''
              defer=''
              crossorigin='anonymous'
              src='https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&amp;version=v6.0'
              integrity='sha384-tGX9ELjlGPfAjLclS6ecSCLOYvJv8fPBjbWdPdsWANwE4VxBwBPmhPqBnqFsuT0Y'
            />
            <div
              class='fb-post d-block'
              data-href={fbLink}
              data-show-text='false'
              data-width='auto'
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

// 編輯器
export class WidgetFacebookMallEditor extends Component {
  render() {
    return (
      <div className='vu-blocks-editor'>
        <div class='components-placeholder__label'>
          <span class='block-editor-block-icon'>
            <div class='dashicons dashicons-cloud' />
          </span>
          天氣元件
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/widget/widget-facebook-mall.js